import React, { PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';

import { fetchEvent } from '../../state/actions';
import { trackTicketsVisit } from '../../utils/tracking';

import EventTicketsPage from './component';
import { mapStateToProps as eventDetailMapStateToProps } from '../../containers/EventDetailPage';

import { getObjFromHashParamString } from '../../utils/urls';

/**
 * Wrap page component with event fetch and loading state and tracking.
 */
class EventTicketsPageContainer extends PureComponent {
  componentWillMount() {
    // If the error has a status code, overwrite the route
    const { error, route } = this.props;
    if (error && error.status) {
      route.status = error.status;
    }
  }

  componentDidMount() {
    const { event, router, location } = this.props;
    // Push the event slug to the URL if it's absent
    if (event && !router.params.eventSlug) {
      router.replace(`${event.permalink}/tickets${location.search}${location.hash}`);
    }
    if (event) {
      trackTicketsVisit(event, getObjFromHashParamString(location.hash).source);
    }
  }

  componentDidUpdate(prevProps) {
    // Event is async on client-side render if the user hasn't alerady requested the data
    const { event, location } = this.props;
    if (event && !prevProps.event) {
      trackTicketsVisit(event, getObjFromHashParamString(location.hash).source);
    }
  }

  render() {
    return <EventTicketsPage {...this.props} />;
  }
}

EventTicketsPageContainer.propTypes = EventTicketsPage.propTypes;

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventTicketsPageWithConnect = connect(eventDetailMapStateToProps)(EventTicketsPageContainer);

// Tickets are only in the full event response, requiring this promise on both client and server
export const asyncPromises = [{
  promise: ({ params, store: { dispatch } }) => dispatch(fetchEvent(params.eventId)),
}];

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
// Configure promises that must be fulfilled before the component is rendered, e.g. fetch event data
const EventTicketsPageContainerWithAsync = asyncConnect(asyncPromises)(EventTicketsPageWithConnect); // eslint-disable-line max-len

export default EventTicketsPageContainerWithAsync;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/container.jsx